import { type UploadFile } from 'antd';
import { useQuery } from '@tanstack/react-query';
import Api from '@/services/api';
import type { BaseContext } from '@/types';
import { ROSA_QUERY_KEYS } from './query-keys';
import type { RosaReportImage } from '@/types/entities/Rosa';

type Images = RosaReportImage & {
	image_url: string;
};

type GetRosaRequest = BaseContext & {
	report_id: string;
};

type GetRosaImagesResponse = {
	images: Images[];
};

async function getImages(params: GetRosaRequest): Promise<GetRosaImagesResponse> {
	const { report_id } = params;
	const url = `ergonomic-tool/rosa/images/${report_id}`;
	const { data } = await Api.get(url, { params });
	return data;
}

function formatImageData(data: GetRosaImagesResponse) {
	const images: UploadFile[] = data?.images.map((image) => {
		return {
			uid: image.id,
			name: image.image_url,
			description: image.description,
			status: 'done',
			url: image.image_url
		};
	});

	return images;
}

export const useGetRosaImages = (params: GetRosaRequest) => {
	return useQuery([ROSA_QUERY_KEYS.GET_ROSA_IMAGES], () => getImages(params), {
		select: formatImageData
	});
};
